var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0003 6.55339C17.4537 4.84672 19.6803 3.76672 22.0003 3.76672C26.107 3.76672 29.3337 6.99339 29.3337 11.1001C29.3337 16.1359 24.8078 20.24 17.9506 26.4581L17.9337 26.4734L16.0003 28.2334L14.067 26.4867L14.0144 26.4389C7.17717 20.2257 2.66699 16.1272 2.66699 11.1001C2.66699 6.99339 5.89366 3.76672 10.0003 3.76672C12.3203 3.76672 14.547 4.84672 16.0003 6.55339ZM16.0003 24.6334L16.1337 24.5001C22.4803 18.7534 26.667 14.9534 26.667 11.1001C26.667 8.43339 24.667 6.43339 22.0003 6.43339C19.947 6.43339 17.947 7.75339 17.2537 9.58006H14.7603C14.0537 7.75339 12.0537 6.43339 10.0003 6.43339C7.33366 6.43339 5.33366 8.43339 5.33366 11.1001C5.33366 14.9534 9.52033 18.7534 15.867 24.5001L16.0003 24.6334Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteBorder);
export default __webpack_public_path__ + "static/media/favoriteBorder.c94a12f01c6efd2de3c336d215bfe8d3.svg";
export { ForwardRef as ReactComponent };